<ng-container *ngIf="messages$ | async as messages">
    <div *ngFor="let message of messages; trackBy: trackByUuid" @Grow>
        <app-message [message]="message"></app-message>
    </div>
</ng-container>
